module.exports = __webpack_public_path__ + "img/yxcstj.2208ab6e.png";